export default {
  price: 'Цена',
  button: {
    default: 'Смотреть',
    new: 'К заданию',
    awaitReview: 'Оставить отзыв',
    error: 'Исправить ошибку',
  },
}